/* Deco Gear page B, desktop hero (sections/dg-hybrid-desk.liquid). Classic script, deferred, no dependencies.
   At every width it only tags the Clarity session; the desktop behaviour starts the first time
   (min-width:861px) matches, after DOMContentLoaded (dg-duo.liquid's three.js / dg-spin.js / dg-delivery.js come
   later in the document). Below 861px the section is display:none and its 3D is not mounted: the Duo hero
   (dg-duo.js) owns the phone, and mounts its own 3D only at <= 860px when this section is on the page. */
(function () {
  'use strict';
  var MQ = '(min-width:861px)';
  var mq = window.matchMedia ? matchMedia(MQ) : { matches: true, addListener: function () {} };

  /* Microsoft Clarity: always call window.clarity at call time (the loader replaces the queue stub). */
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  function cl() { try { return window.clarity.apply(window, arguments); } catch (e) {} }
  function ev(n) { cl('event', n); cl('upgrade', n); }
  cl('set', 'pdp_variant', 'B');
  cl('set', 'pdp_layout', mq.matches ? 'hybrid-desk' : 'duo-phone');

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function reduce() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function onMq(fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  var root = null, started = false, api = null;
  ready(function () {
    root = document.querySelector('[data-dgh]');
    if (!root) return;
    if (mq.matches) start();
    onMq(function () {
      if (mq.matches) { start(); if (api) api.enter(); }
      else if (api) api.leave();
    });
  });

  function start() {
    if (started) return; started = true;
    api = init(root);
    api.enter();
  }

  function init(root) {
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var sid = root.getAttribute('data-section-id');
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var ships = root.getAttribute('data-ships') !== 'false';
    var okNow = root.getAttribute('data-buyable') === 'true', lastDel = null;
    var errEl = form && form.querySelector('.dgh-error');

    /* ---------- nav burger (861-960px) ---------- */
    var burger = document.getElementById('pdp-nav-burger-' + sid), drawer = document.getElementById('pdp-nav-drawer-' + sid);
    if (burger && drawer) {
      var setDrawer = function (on) { drawer.hidden = !on; burger.setAttribute('aria-expanded', on ? 'true' : 'false'); burger.setAttribute('aria-label', on ? 'Close navigation menu' : 'Open navigation menu'); };
      burger.addEventListener('click', function (e) { e.stopPropagation(); setDrawer(drawer.hidden); });
      drawer.addEventListener('click', function (e) { if (e.target.closest('a')) setDrawer(false); });
      document.addEventListener('click', function (e) { if (!drawer.hidden && !drawer.contains(e.target) && !burger.contains(e.target)) setDrawer(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) { setDrawer(false); burger.focus(); } });
    }

    /* ---------- errors (quantity over stock etc.) ---------- */
    function showError(msg) {
      if (!errEl) return; errEl.textContent = msg; errEl.hidden = false;
      var r = errEl.getBoundingClientRect();
      if (r.top < 150 || r.bottom > innerHeight) errEl.scrollIntoView({ block: 'center', behavior: reduce() ? 'auto' : 'smooth' });
    }
    function hideError() { if (errEl && !errEl.hidden) { errEl.hidden = true; errEl.textContent = ''; } }

    /* ---------- quantity stepper: real name="quantity", capped at stock; aria-disabled at the limits ---------- */
    var qty = (function () {
      var box = $('[data-dgh-qty]'); if (!box) return null;
      var inp = box.querySelector('[data-dgh-qty-in]'), dec = box.querySelector('[data-dgh-qty-dec]'), inc = box.querySelector('[data-dgh-qty-inc]'), live = box.querySelector('[data-dgh-qty-live]');
      if (!inp || !dec || !inc) return null;
      var max = Math.max(1, +inp.max || 999);
      function val() { var v = parseInt(inp.value, 10); return isNaN(v) ? 1 : v; }
      function set(v, say) {
        v = Math.max(1, Math.min(max, v | 0)); inp.value = v;
        dec.setAttribute('aria-disabled', v <= 1 ? 'true' : 'false'); inc.setAttribute('aria-disabled', v >= max ? 'true' : 'false');
        if (say && live) live.textContent = 'Quantity ' + v;
        hideError();
      }
      dec.addEventListener('click', function () { if (dec.getAttribute('aria-disabled') !== 'true') set(val() - 1, true); });
      inc.addEventListener('click', function () { if (inc.getAttribute('aria-disabled') !== 'true') set(val() + 1, true); });
      inp.addEventListener('change', function () { set(val(), false); });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); set(val(), false); } });
      set(val(), false);
      return { get: val, setMax: function (m) { max = Math.max(1, m); inp.max = max; set(val(), false); } };
    })();

    /* ---------- Add to cart -> /cart, Buy now -> checkout (same as the Duo hero) ---------- */
    function nativeGo(kind, b) {
      var h = form.querySelector('input[name="checkout"]');
      if (kind === 'checkout') { if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = 'Checkout'; form.appendChild(h); } }
      else if (h) h.remove();
      var rt = form.querySelector('input[name="return_to"]');
      if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
      rt.value = kind === 'checkout' ? '/checkout' : '/cart';
      b.setAttribute('aria-busy', 'true');
      HTMLFormElement.prototype.submit.call(form);
    }
    function ajaxAdd(kind, b) {
      var fd = new FormData(form), drop = [];
      fd.delete('checkout'); fd.delete('return_to');
      fd.forEach(function (v, k) { if (/^properties\[Estimated/.test(k)) drop.push(k); });
      drop.forEach(function (k) { fd.delete(k); });
      b.setAttribute('aria-busy', 'true');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j || {} }; }); })
        .then(function (res) {
          if (res.ok) { location.assign(kind === 'checkout' ? '/checkout' : '/cart'); return; }
          b.removeAttribute('aria-busy');
          var msg = res.j.description || res.j.message;
          if (msg) showError(String(msg)); else nativeGo(kind, b);
        })
        .catch(function () { b.removeAttribute('aria-busy'); nativeGo(kind, b); });
    }
    function go(kind, b) {
      if (!form || b.disabled) return;
      stripEst();
      if (qty && qty.get() > 1 && window.fetch && window.FormData && FormData.prototype.delete) ajaxAdd(kind, b);
      else nativeGo(kind, b);
    }
    $$('[data-dgh-buynow]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go('checkout', b); }); });
    $$('.pdp__atc,[data-dgh-bar-add]').forEach(function (b) { b.addEventListener('click', function (e) { if (!form || b.disabled) return; e.preventDefault(); go('cart', b); }); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !form) return;
      $$('[aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      ['checkout', 'return_to'].forEach(function (n) { var i = form.querySelector('input[name="' + n + '"]'); if (i) i.remove(); });
    });
    // The "Estimated Delivery Date Plus" app injects properties[Estimated ...] inputs into product forms (a different
    // date range than our delivery line); keep them off items added from this form, as the Duo hero does.
    function stripEst() { if (form) Array.prototype.forEach.call(form.querySelectorAll('input[name^="properties[Estimated"]'), function (i) { i.remove(); }); }
    if (form) { stripEst(); try { new MutationObserver(stripEst).observe(form, { childList: true, subtree: true }); } catch (e) {} }

    /* ---------- variant: price, list price, Save %, SKU, stock, Shop Pay, bar, delivery, qty cap, URL ---------- */
    var sel = $('[data-dgh-vsel]');
    function applyVariant(o) {
      var d = o.dataset, ok = d.available === 'true', has = !!d.compare;
      var input = form && form.querySelector('[data-dgh-variant]'); if (input) input.value = o.value;
      $$('[data-dgh-price]').forEach(function (n) { n.textContent = d.price; });
      $$('[data-dgh-was]').forEach(function (n) { n.textContent = d.compare || ''; });
      $$('[data-dgh-deal]').forEach(function (n) { n.hidden = !has; });
      $$('[data-dgh-save]').forEach(function (n) { n.textContent = has ? 'Save ' + d.savePct + '%' : ''; });
      $$('[data-dgh-sku]').forEach(function (n) { n.textContent = d.sku || ''; });
      var st = $('[data-dgh-stock]'), meta = $('[data-dgh-meta]');
      if (st) st.textContent = ok ? 'In stock' : 'Currently unavailable';
      if (meta) meta.classList.toggle('is-out', !ok);
      var fin = $('[data-dgh-fin]'), fm = $('[data-dgh-fin-mo]'), mo = +d.fin || 0;
      if (fin && fm) { fm.textContent = mo; fin.hidden = !(mo >= 5); }
      var vl = $('[data-dgh-vlabel]'); if (vl) vl.textContent = d.name || o.textContent;
      var bo = $('[data-dgh-bar-opt]'); if (bo) bo.textContent = d.name || o.textContent;
      $$('.pdp__atc,.pdp__buynow,.dgh-bar button').forEach(function (b) { b.disabled = !ok; });
      var atc = $('.pdp__atc'); if (atc) atc.textContent = ok ? 'Add to Cart' : 'Sold out';
      if (!has) setTip(false);
      okNow = ok; paintDelivery();
      if (qty) qty.setMax(+d.max || 999);
      hideError();
      try { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    }
    if (sel) {
      sel.addEventListener('change', function () { applyVariant(sel.options[sel.selectedIndex]); ev('duo_variant'); });
      var hid = form && form.querySelector('[data-dgh-variant]');
      if (hid && hid.value !== sel.value) applyVariant(sel.options[sel.selectedIndex]);  // form restore on back nav
    }

    /* ---------- delivery: DGDelivery (exact port of the old section's estimate) ---------- */
    function paintDelivery() {
      if (!ships) return;
      var dl = $('[data-dgh-dl]'), sub = $('[data-dgh-sub]'), bd = $('[data-dgh-bar-del]');
      if (!dl) return;
      if (!okNow) { dl.textContent = 'Currently sold out'; if (sub) sub.textContent = ' '; if (bd) bd.textContent = 'Sold out'; return; }
      if (!lastDel) { dl.textContent = 'Free shipping'; if (sub) sub.textContent = 'Typically 3–5 business days'; if (bd) bd.textContent = 'Free delivery'; return; }
      dl.textContent = 'Free delivery '; var b = document.createElement('b'); b.textContent = lastDel.deliveryShort; dl.appendChild(b);
      if (sub) sub.textContent = lastDel.shipLabel + ' · order within ' + lastDel.orderWithin;
      if (bd) bd.textContent = 'Free delivery ' + lastDel.deliveryShort;
    }
    function zip3() { try { return sessionStorage.getItem((window.DGDelivery && DGDelivery.KEY) || 'dg_zip3'); } catch (e) { return null; } }
    function fillDelivery() {
      if (!ships) return true;
      var D = window.DGDelivery; if (!D) return false;
      if (!document.querySelector('[data-dgd]')) { D.init(function (r) { lastDel = r; paintDelivery(); }); return true; }
      // The Duo section on this page already ran DGDelivery.init() (one ipapi.co lookup per session, cached as a
      // ZIP3 in sessionStorage). Same result without a second lookup: estimate from the cached ZIP3, else the
      // default 088 now, then pick up the ZIP3 when that lookup stores it.
      var z = zip3();
      lastDel = D.estimate(Date.now(), z || '088'); paintDelivery();
      if (!z) { var n = 0; (function chk() { var z2 = zip3(); if (z2) { lastDel = D.estimate(Date.now(), z2); paintDelivery(); return; } if (++n < 10) setTimeout(chk, 1000); })(); }
      return true;
    }
    paintDelivery();
    if (!fillDelivery()) window.addEventListener('load', fillDelivery);

    /* ---------- list-price (i) note ---------- */
    var ib = $('.dgh-itip'), tip = ib && document.getElementById(ib.getAttribute('aria-controls'));
    function setTip(on) {
      if (!tip || !ib) return; tip.hidden = !on; ib.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var p = tip.parentNode.getBoundingClientRect(), r = ib.getBoundingClientRect(); tip.style.setProperty('--tip-x', Math.round(r.left + r.width / 2 - p.left) + 'px'); }
    }
    if (ib && tip) {
      ib.addEventListener('click', function (e) { e.stopPropagation(); if (tip.hidden) ev('duo_listprice_info'); setTip(tip.hidden); });
      document.addEventListener('click', function (e) { if (!tip.hidden && !tip.contains(e.target)) setTip(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !tip.hidden) { setTip(false); ib.focus(); } });
    }

    /* ---------- rating: mirror Bazaarvoice's inline summary into gold stars (Duo's scan); never hard-coded ---------- */
    (function () {
      var bv = $('[data-dgh-bv]'), slot = $('[data-dgh-rateslot]'), row = $('[data-dgh-raterow]'); if (!bv || !slot) return;
      var mo = null, giveUp = 0;
      function finish() { if (mo) mo.disconnect(); clearTimeout(giveUp); if (row) row.classList.remove('is-wait'); }
      function scan() {
        var lab = bv.querySelector('[aria-label*="rating value"]');
        var mv = lab && /([0-9]+(?:\.[0-9]+)?)\s*of\s*5/i.exec(lab.getAttribute('aria-label') || '');
        var mc = /\(([0-9][0-9,]*)\)/.exec(bv.innerText || bv.textContent || '');
        if (!mv || !mc) return false;
        var v = parseFloat(mv[1]), n = parseInt(mc[1].replace(/,/g, ''), 10);
        finish();
        if (!(n > 0) || !(v > 0)) { bv.classList.add('is-done'); slot.hidden = true; return true; }
        var full = Math.max(0, Math.min(5, Math.round(v))), stars = '', vs = (Math.round(v * 10) / 10).toFixed(1), rv = n === 1 ? ' review' : ' reviews';
        for (var i = 1; i <= 5; i++) stars += i <= full ? '★' : '<u>★</u>';
        var a = document.createElement('a');
        a.className = 'dgh-stars'; a.href = '#dg-reviews';
        a.setAttribute('aria-label', 'Rated ' + vs + ' out of 5 from ' + n + rv);
        a.innerHTML = '<i aria-hidden="true">' + stars + '</i><b aria-hidden="true">' + vs + '</b><span aria-hidden="true">· ' + n.toLocaleString('en-US') + rv + '</span>';
        slot.insertBefore(a, bv);
        bv.classList.remove('is-raw'); bv.classList.add('is-done');
        return true;
      }
      if (!scan()) {
        if ('MutationObserver' in window) { mo = new MutationObserver(scan); mo.observe(bv, { childList: true, subtree: true, characterData: true, attributes: true }); }
        giveUp = setTimeout(function () { if (!scan()) { bv.classList.add('is-raw'); slot.style.minWidth = '320px'; if (row) row.classList.remove('is-wait'); setTimeout(function () { if (mo) mo.disconnect(); }, 20000); } }, 10000);
      }
    })();

    /* ---------- gallery: 3D thumb (first, active), photo thumbs, "+N photos", fullscreen ---------- */
    var box = $('[data-dgh-box]'), d3 = $('[data-dgh-3d]'), t3 = $('[data-dgh-3d-thumb]');
    var img1 = document.getElementById('pdp-stack-img1-' + sid), fsBtn = document.getElementById('pdp-fullscreen-btn-' + sid);
    var photoThumbs = $$('.pdp__stack-thumb'), curPhoto = 0;
    if (img1) img1.style.transition = 'opacity .2s ease, transform .3s ease';
    function press(btn) {
      if (t3) { t3.classList.toggle('is-active', btn === t3); t3.setAttribute('aria-pressed', btn === t3 ? 'true' : 'false'); }
      photoThumbs.forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    function show3D() { if (!d3) return; d3.classList.remove('is-off'); if (box) box.classList.remove('is-photo'); press(t3); }
    function showPhoto(i) {
      var b = photoThumbs[i]; if (!b) return;
      curPhoto = i; press(b);
      if (d3) d3.classList.add('is-off');
      if (box) box.classList.add('is-photo');
      var src = b.getAttribute('data-src');
      if (img1 && src && img1.getAttribute('src') !== src) {
        img1.style.opacity = '0';
        setTimeout(function () { img1.removeAttribute('srcset'); img1.removeAttribute('sizes'); img1.removeAttribute('loading'); img1.src = src; img1.alt = lbAlt(i); img1.style.opacity = '1'; }, 120);
      }
    }
    if (t3) t3.addEventListener('click', function () { show3D(); ev('duo_3d'); });
    photoThumbs.forEach(function (b, i) { b.addEventListener('click', function () { showPhoto(i); }); });

    /* ---------- lightbox (old markup; focus trap, Esc, arrows, return focus) ---------- */
    var lb = document.getElementById('pdp-lightbox-' + sid), lbImg = document.getElementById('pdp-lightbox-img-' + sid), lbClose = document.getElementById('pdp-lightbox-close-' + sid);
    var lbThumbs = lb ? Array.prototype.slice.call(lb.querySelectorAll('.pdp__lightbox-thumb')) : [], lbCur = 0, lbOpener = null;
    function lbAlt(i) { var t = lbThumbs[i]; return t ? t.getAttribute('data-alt') || '' : ''; }
    function lbShow(i) {
      i = Math.max(0, Math.min(lbThumbs.length - 1, i)); lbCur = i; var t = lbThumbs[i]; if (!t || !lbImg) return;
      var im = lbImg.querySelector('img'); if (!im) { im = document.createElement('img'); lbImg.appendChild(im); }
      im.src = t.getAttribute('data-src'); im.alt = lbAlt(i);
      lbThumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    }
    function lbTrap(e) {
      if (e.key === 'Escape') { e.preventDefault(); lbHide(); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbCur + 1); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbCur - 1); return; }
      if (e.key !== 'Tab') return;
      var f = lb.querySelectorAll('button,[href],[tabindex]:not([tabindex="-1"])'); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function lbOpen(i, from) {
      if (!lb) return; lbOpener = from || document.activeElement; lbShow(i);
      lb.hidden = false; document.documentElement.style.overflow = 'hidden';
      lb.addEventListener('keydown', lbTrap); if (lbClose) lbClose.focus({ preventScroll: true });
      ev('duo_photos_open');
    }
    function lbHide() {
      if (!lb || lb.hidden) return; lb.hidden = true; document.documentElement.style.overflow = '';
      lb.removeEventListener('keydown', lbTrap); if (lbOpener && lbOpener.focus) lbOpener.focus({ preventScroll: true });
    }
    if (lb) {
      if (lbClose) lbClose.addEventListener('click', lbHide);
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg) lbHide(); });
      lbThumbs.forEach(function (b, k) { b.addEventListener('click', function () { lbShow(k); }); });
    }
    var more = $('[data-dgh-more]');
    if (more) more.addEventListener('click', function () { lbOpen(Math.min(6, lbThumbs.length - 1), more); });
    if (fsBtn) fsBtn.addEventListener('click', function () { lbOpen(curPhoto, fsBtn); });

    /* ---------- DecoDash, persona pills, "See more" ---------- */
    var dashBtn = document.getElementById('pdp-dash-btn-' + sid), dashEx = document.getElementById('pdp-dash-expand-' + sid);
    if (dashBtn && dashEx) dashBtn.addEventListener('click', function () {
      var on = dashEx.classList.toggle('is-open'); dashBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      Array.prototype.forEach.call(dashEx.querySelectorAll('a'), function (a) { a.tabIndex = on ? 0 : -1; });
    });
    var pills = $$('.pdp__persona-pill');
    pills.forEach(function (p) { p.addEventListener('click', function () { pills.forEach(function (q) { var on = q === p; q.classList.toggle('is-active', on); q.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }); });
    var exBtn = document.getElementById('pdp-expand-btn-' + sid), bul = document.getElementById('pdp-bullets-' + sid);
    if (exBtn && bul) exBtn.addEventListener('click', function () {
      var open = exBtn.getAttribute('aria-expanded') !== 'true';
      Array.prototype.forEach.call(bul.children, function (li, i) { if (i >= 3) li.hidden = !open; });
      exBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      exBtn.querySelector('.pdp__expand-label').textContent = open ? 'See less' : 'See more';
    });

    /* ---------- craftsmanship video: load when near view (desktop only), pause off-screen ---------- */
    (function () {
      var conn = navigator.connection || {}, slow = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
      $$('video[data-src]').forEach(function (v) {
        if (slow || !('IntersectionObserver' in window)) return;
        new IntersectionObserver(function (es, o) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            if (v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); v.removeAttribute('data-src'); v.preload = 'auto'; }
            o.disconnect();
            new IntersectionObserver(function (xs) { xs.forEach(function (x) { if (x.isIntersecting && !reduce()) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: .3 }).observe(v);
          });
        }, { rootMargin: '200px' }).observe(v);
      });
    })();

    /* ---------- top buy bar: shown once the buy buttons pass under the nav (no scroll polling) ---------- */
    var bar = $('[data-dgh-bar]'), ctas = $('.dgh-ctas'), barOn = false;
    function setBar(on) {
      if (!bar || on === barOn) return; barOn = on;
      bar.classList.toggle('is-on', on); bar.inert = !on;
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      root.classList.toggle('is-bar', on);
    }
    if (bar && ctas && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { var e = es[es.length - 1]; setBar(!e.isIntersecting && e.boundingClientRect.top < 110); }, { rootMargin: '-110px 0px 0px 0px' }).observe(ctas);
    }

    /* ---------- pinned left column: top = min(102, vh - colH - 16); with the bar, slide down by transform ---------- */
    var col = $('[data-dgh-col]');
    function pin() {
      if (!col || !mq.matches) return;
      var vh = innerHeight, h = col.offsetHeight, p = Math.min(102, Math.round(vh - h - 16));
      var s = Math.max(0, Math.min(64, Math.round(vh - 16 - p - h)));
      root.style.setProperty('--dgh-pin', p + 'px'); root.style.setProperty('--dgh-shift', s + 'px');
    }
    if (col) { pin(); if ('ResizeObserver' in window) new ResizeObserver(pin).observe(col); addEventListener('resize', pin); }

    /* ---------- 3D turntable (one hero WebGL context per breakpoint) + "See it in action" ---------- */
    var spin = { on: false, token: 0, S: null, gl: null, timer: 0, land: 0, state: 'idle', mode: null };
    var replay = d3 && d3.querySelector('[data-dgh-replay]');
    function dd(k) { return d3.getAttribute('data-' + k); }
    function webgl() { try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); } catch (e) { return false; } }
    function load(src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.async = false; s.onload = res; s.onerror = function () { rej(new Error('load ' + src)); }; document.head.appendChild(s); }); }
    function kill(S, canvas) {   // destroy + release the GL context, then a fresh canvas for a later mount
      try { S.stopScreen(); S.destroy(); } catch (e) {}
      try { var c = canvas.getContext('webgl2') || canvas.getContext('webgl'); var x = c && c.getExtension('WEBGL_lose_context'); if (x) x.loseContext(); } catch (e) {}
      var n = canvas.cloneNode(false); if (canvas.parentNode) canvas.parentNode.replaceChild(n, canvas); return n;
    }
    // landing screen (as the Duo hero): colour ribbons, then the white logo
    var logo = null, fld = null, fx = null, RIB = [[255, 64, 129], [255, 149, 0], [0, 199, 255], [124, 77, 255], [0, 230, 160]];
    function colour(x, w, h, t) {
      if (!fld) { fld = document.createElement('canvas'); fld.width = 384; fld.height = 108; fx = fld.getContext('2d'); }
      fx.fillStyle = '#07081a'; fx.fillRect(0, 0, 384, 108); fx.globalCompositeOperation = 'lighter';
      RIB.forEach(function (c, k) {
        var ph = t * .35 + k * 1.3; fx.beginPath();
        for (var i = 0; i <= 48; i++) { var X = i / 48 * 384, Y = 54 + Math.sin(i / 48 * Math.PI * 2 * (.8 + k * .15) + ph) * 26 + Math.sin(i / 9 + ph * 1.7) * 7; if (i) fx.lineTo(X, Y); else fx.moveTo(X, Y); }
        fx.lineWidth = 18 + 8 * Math.sin(ph * .7);
        var g = fx.createLinearGradient(0, 0, 384, 0); g.addColorStop(0, 'rgba(' + c + ',0)'); g.addColorStop(.5, 'rgba(' + c + ',.85)'); g.addColorStop(1, 'rgba(' + c + ',.15)');
        fx.strokeStyle = g; fx.filter = 'blur(7px)'; fx.stroke();
      });
      fx.filter = 'none'; fx.globalCompositeOperation = 'source-over';
      x.imageSmoothingQuality = 'high'; x.drawImage(fld, 0, 0, w, h);
      var a = Math.min(1, Math.max(0, (t - .35) / .6));
      if (logo && logo.complete && logo.naturalWidth && a > 0) {
        var lw = w * .34, lh = lw * 41.81 / 319.26, s = .96 + .04 * a;
        x.save(); x.globalAlpha = a; x.translate(w / 2, h / 2); x.scale(s, s); x.shadowColor = 'rgba(0,0,0,.35)'; x.shadowBlur = 24; x.drawImage(logo, -lw / 2, -lh / 2, lw, lh); x.restore();
      }
    }
    // screen painters for the modes (drawn at the screen texture size w x h, 32:9) - from the approved mock
    function R(x, c, X, Y, W, H, r) { x.fillStyle = c; x.beginPath(); if (x.roundRect) x.roundRect(X, Y, W, H, r || 0); else x.rect(X, Y, W, H); x.fill(); }
    var P = {
      work: function (x, w, h) { var g = x.createLinearGradient(0, 0, w, h); g.addColorStop(0, '#dfe7f5'); g.addColorStop(1, '#eef0f6'); x.fillStyle = g; x.fillRect(0, 0, w, h);
        var pad = h * .08, cw = (w - pad * 4) / 3, ch = h - pad * 2;
        [['#ffffff', 'sheet'], ['#1e1e2a', 'code'], ['#ffffff', 'chat']].forEach(function (c, i) { var X = pad + i * (cw + pad); R(x, c[0], X, pad, cw, ch, h * .04); R(x, i === 1 ? '#2b2b3b' : '#f1f3f8', X, pad, cw, h * .09, h * .04);
          if (c[1] === 'sheet') { x.strokeStyle = '#d8dce6'; x.lineWidth = Math.max(1, h * .004); for (var r = 0; r < 9; r++) { x.beginPath(); x.moveTo(X, pad + h * .15 + r * ch * .09); x.lineTo(X + cw, pad + h * .15 + r * ch * .09); x.stroke(); } for (var q = 1; q < 5; q++) { x.beginPath(); x.moveTo(X + q * cw / 5, pad + h * .09); x.lineTo(X + q * cw / 5, pad + ch); x.stroke(); } R(x, '#34c759', X + cw * .22, pad + ch * .62, cw * .12, ch * .25, 2); R(x, '#0071e3', X + cw * .42, pad + ch * .48, cw * .12, ch * .39, 2); R(x, '#ff9f0a', X + cw * .62, pad + ch * .55, cw * .12, ch * .32, 2); }
          if (c[1] === 'code') { var cols = ['#ff7ab2', '#7ee787', '#79c0ff', '#d2a8ff', '#ffa657']; for (var l = 0; l < 10; l++) { var ind = (l % 3) * cw * .05; R(x, cols[l % 5], X + cw * .07 + ind, pad + h * .15 + l * ch * .075, cw * (.25 + ((l * 37) % 40) / 100), ch * .03, 2); } }
          if (c[1] === 'chat') { for (var b = 0; b < 5; b++) { var me = b % 2; R(x, me ? '#0071e3' : '#e9e9ef', me ? X + cw * .42 : X + cw * .06, pad + h * .15 + b * ch * .15, cw * .52, ch * .1, h * .03); } } }); },
      game: function (x, w, h) { var g = x.createLinearGradient(0, 0, 0, h); g.addColorStop(0, '#1b1036'); g.addColorStop(.45, '#ff5e62'); g.addColorStop(.62, '#ffb347'); g.addColorStop(.63, '#151022'); g.addColorStop(1, '#07060c'); x.fillStyle = g; x.fillRect(0, 0, w, h);
        x.fillStyle = 'rgba(255,220,150,.9)'; x.beginPath(); x.arc(w * .5, h * .6, h * .16, Math.PI, 0); x.fill();
        x.fillStyle = '#2a1838'; x.beginPath(); x.moveTo(0, h * .63); for (var i = 0; i <= 20; i++) { x.lineTo(i * w / 20, h * (.5 + ((i * 7) % 5) / 40)); } x.lineTo(w, h * .63); x.fill();
        x.strokeStyle = 'rgba(255,90,200,.85)'; x.lineWidth = Math.max(1, h * .006); for (var k = -14; k <= 14; k++) { x.beginPath(); x.moveTo(w * .5, h * .63); x.lineTo(w * .5 + k * w * .06, h); x.stroke(); } for (var j = 1; j < 7; j++) { var y = h * .63 + Math.pow(j / 7, 1.8) * h * .37; x.beginPath(); x.moveTo(0, y); x.lineTo(w, y); x.stroke(); }
        R(x, 'rgba(0,0,0,.45)', w * .02, h * .06, w * .1, h * .12, h * .03); x.fillStyle = '#fff'; x.font = '600 ' + Math.round(h * .07) + 'px -apple-system,sans-serif'; x.fillText('120 FPS', w * .03, h * .145); },
      create: function (x, w, h) { x.fillStyle = '#1c1c1e'; x.fillRect(0, 0, w, h); var vw = w * .62, vh = h * .62, vx = w * .04, vy = h * .07;
        var g = x.createLinearGradient(vx, 0, vx + vw, 0); g.addColorStop(0, '#0a84ff'); g.addColorStop(.35, '#5e5ce6'); g.addColorStop(.6, '#ff375f'); g.addColorStop(1, '#ffd60a'); x.fillStyle = g; x.fillRect(vx, vy, vw, vh);
        x.fillStyle = 'rgba(255,255,255,.08)'; x.beginPath(); x.arc(vx + vw * .7, vy + vh * .35, vh * .3, 0, 7); x.fill();
        var px = vx + vw + w * .03, pw = w - px - w * .03; for (var i = 0; i < 4; i++) { R(x, '#2c2c2e', px, vy + i * vh * .26, pw, vh * .2, h * .02); var cc = ['#ff453a', '#30d158', '#0a84ff', '#ffd60a'][i]; R(x, cc, px + pw * .08, vy + i * vh * .26 + vh * .08, pw * (.3 + i * .15), vh * .04, 3); }
        var ty = vy + vh + h * .06; for (var r = 0; r < 3; r++) { for (var c = 0; c < 8; c++) { R(x, ['#5e5ce6', '#ff9f0a', '#30d158'][r], w * .04 + c * w * .115 + ((r * 31) % 40), ty + r * h * .075, w * .1, h * .055, h * .012); } } },
      split: function (x, w, h) { x.fillStyle = '#0b0b0f'; x.fillRect(0, 0, w, h); var half = w / 2;
        [['#e9eef9', 'PC'], ['#f6efe6', 'Laptop']].forEach(function (s, i) { var X = i * half; x.fillStyle = s[0]; x.fillRect(X + h * .03, h * .03, half - h * .06, h - h * .06);
          R(x, 'rgba(0,0,0,.08)', X + h * .03, h * .03, half - h * .06, h * .1, 0); for (var r = 0; r < 4; r++) { R(x, '#ffffff', X + half * .08 + r * half * .22, h * .22, half * .18, h * .5, h * .02); }
          x.fillStyle = '#1d1d1f'; x.font = '600 ' + Math.round(h * .08) + 'px -apple-system,sans-serif'; x.fillText(s[1], X + half * .08, h * .88); });
        x.fillStyle = '#0071e3'; x.fillRect(half - h * .006, h * .03, h * .012, h - h * .06); }
    };
    function goLanding() {
      var S = spin.S; if (!S) return;
      clearTimeout(spin.timer); clearTimeout(spin.land); d3.classList.remove('is-landed');
      S.stopScreen(); S.paintScreen(function (x, w, h) { colour(x, w, h, 0); });
      spin.state = 'playing';
      S.play({ from: 390, to: 0, dur: 3400 }).then(function () { if (spin.S === S) spin.state = 'landed'; });
      spin.land = setTimeout(function () { if (spin.S !== S || spin.mode) return; S.screenLoop(function (x, w, h, t) { colour(x, w, h, Math.min(t, 5)); if (t > 5.2) S.stopScreen(); }); }, 3400);
    }
    function paintMode(k) {
      var S = spin.S; if (!S || !P[k]) return;
      clearTimeout(spin.timer); clearTimeout(spin.land);
      S.stopScreen(); S.paintScreen(function (x, w, h) { P[k](x, w, h); });
      if (spin.state === 'idle') {   // landing not started yet: turn in with this mode on the screen
        spin.state = 'playing';
        S.play({ from: 390, to: 0, dur: 3400 }).then(function () { if (spin.S === S) spin.state = 'landed'; });
      } else if (spin.state === 'landed') { S.setAz(0); S.draw(); }
      // 'playing': the turn ends at the front and lights the screen with this content
    }
    function mount3D() {
      if (!d3 || spin.on) return; spin.on = true; var my = ++spin.token;
      if (reduce() || !webgl()) { root.classList.add('no-3d'); return; }
      var gl = d3.querySelector('[data-dgh-gl]');
      var chain = window.THREE ? Promise.resolve() : load(dd('three'));
      chain.then(function () { return window.DGSpin ? null : load(dd('spin')); }).then(function () {
        if (my !== spin.token) throw new Error('stale');
        return window.DGSpin.mount(gl, {
          mesh: dd('mesh'), views: dd('views'),
          textures: { front: dd('tex-front'), front34r: dd('tex-front34r'), front34l: dd('tex-front34l'), rear34b: dd('tex-rear34b'), rear34a: dd('tex-rear34a'), rear: dd('tex-rear') },
          onLanded: function () { if (my === spin.token) d3.classList.add('is-landed'); }
        });
      }).then(function (S) {
        if (my !== spin.token || !spin.on) { kill(S, gl); return; }
        spin.S = S; spin.gl = gl; spin.state = 'idle';
        if (!logo) { logo = new Image(); logo.crossOrigin = 'anonymous'; logo.src = dd('logo'); }
        S.paintScreen(function (x, w, h) { colour(x, w, h, 0); });
        d3.classList.add('is-ready');
        if (replay) { replay.hidden = false; replay.onclick = function () { spin.mode = null; goLanding(); }; }
        if (spin.mode) paintMode(spin.mode); else spin.timer = setTimeout(goLanding, 250);
      }).catch(function (e) {
        if (e && e.message === 'stale') return;
        root.classList.add('no-3d');   // poster stays; modes card hidden (last item in its column: no shift)
        if (window.console) console.warn('[dg-hybrid] 3D unavailable:', e && e.message);
      });
    }
    function unmount3D() {
      if (!spin.on) return; spin.on = false; spin.token++;
      clearTimeout(spin.timer); clearTimeout(spin.land);
      if (spin.S) { kill(spin.S, spin.gl); spin.S = null; spin.gl = null; }
      spin.state = 'idle';
      if (d3) d3.classList.remove('is-ready', 'is-landed');
      if (replay) replay.hidden = true;
    }
    var modes = $('[data-dgh-modes]');
    var M = {
      work: ['▦', 'Two QHD screens in one', '5120 × 1440 — spreadsheets, code and chat side by side, no bezel in the middle.'],
      game: ['◐', '120 Hz with Adaptive-Sync', 'A new frame every 8.3 ms, twice as often as 60 Hz, with 1 ms MPRT.'],
      create: ['◑', '100% sRGB on a 49″ curve', '100% sRGB and 91% DCI-P3 across a 49″ 1500R canvas.'],
      split: ['◫', 'Two computers, one screen', 'Picture-by-picture plus built-in KVM: one keyboard and mouse for both.']
    };
    if (modes) {
      var mb = modes.querySelector('[data-dgh-mode-b]'), segs = Array.prototype.slice.call(modes.querySelectorAll('.dgh-seg button'));
      segs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var k = btn.getAttribute('data-m'), m = M[k]; if (!m) return;
          segs.forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
          mb.querySelector('i').textContent = m[0]; mb.querySelector('b').textContent = m[1]; mb.querySelector('span').textContent = m[2];
          spin.mode = k; show3D(); paintMode(k);
          ev('duo_mode'); ev('duo_mode_' + k);
        });
      });
    }

    /* ---------- Peripherals side tab (old section; desktop only) ---------- */
    var periph = null;
    function buildPeriph() {
      if (periph) { periph.style.display = 'flex'; return; }
      var src = $('[data-dgh-periph]'), products = [];
      try { products = JSON.parse(src ? src.textContent : '[]') || []; } catch (e) {}
      if (!products.length) return;
      var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var isOpen = innerWidth >= 1500, isDsk = innerWidth >= 1200, barW = isDsk ? '180px' : '90px';
      var wrap = document.createElement('div'); wrap.id = 'dg-addon-wrapper';
      wrap.style.cssText = 'position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:2147483647;display:flex;align-items:stretch;opacity:0;transition:opacity .4s ease;pointer-events:none;';
      var tab = document.createElement('button'); tab.type = 'button'; tab.setAttribute('aria-label', 'Peripherals'); tab.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      tab.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;width:20px;background:#fff;border:1px solid rgba(0,0,0,.08);border-right:none;border-radius:10px 0 0 10px;cursor:pointer;box-shadow:-2px 0 10px rgba(0,0,0,.1);flex-shrink:0;gap:4px;padding:10px 0;user-select:none;font-family:inherit;';
      tab.innerHTML = '<span style="font-size:8px;font-weight:800;color:#000;writing-mode:vertical-rl;text-orientation:mixed;letter-spacing:.1em;transform:rotate(180deg);line-height:1;">PERIPHERALS</span>';
      var arrow = document.createElement('span'); arrow.setAttribute('aria-hidden', 'true'); arrow.style.cssText = 'font-size:10px;color:#6e6e73;transition:transform .3s;margin-top:2px;'; arrow.textContent = '›'; tab.appendChild(arrow);
      var pb = document.createElement('div'); pb.id = 'dg-addon-bar';
      pb.style.cssText = 'width:' + barW + ';background:#fff;border:1px solid #e0e0e0;border-right:none;border-left:none;padding:10px ' + (isDsk ? '12' : '6') + 'px 14px;display:flex;flex-direction:column;align-items:center;gap:8px;box-shadow:-2px 0 16px rgba(0,0,0,.12);font-family:-apple-system,sans-serif;max-height:80vh;overflow-y:auto;scrollbar-width:none;transition:width .3s ease,opacity .3s ease,padding .3s ease;';
      products.sort(function () { return Math.random() - .5; }); products = products.slice(0, 6);
      var html = '<div style="font-size:10px;font-weight:800;color:#000;text-align:center;padding-bottom:6px;border-bottom:1px solid #eee;width:100%;">Logitech</div><div style="font-size:7px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#767676;text-align:center;width:100%;padding-bottom:6px;border-bottom:1px solid #f0f0f0;margin-bottom:2px;">Add-ons</div>';
      products.forEach(function (p, i) {
        var name = p.title.length > 28 ? p.title.substring(0, 28) + '…' : p.title;
        if (isDsk) {
          if (i > 0) html += '<div style="width:90%;height:1px;background:#f0f0f0;flex-shrink:0;"></div>';
          html += '<a href="' + esc(p.url) + '" style="display:flex;align-items:center;gap:10px;width:100%;padding:4px 2px;text-decoration:none;border-radius:8px;"><div style="width:56px;height:56px;border-radius:8px;overflow:hidden;border:1px solid #ebebeb;background:#f8f8f8;flex-shrink:0;display:flex;align-items:center;justify-content:center;">' + (p.img ? '<img src="' + esc(p.img) + '" style="width:100%;height:100%;object-fit:contain;" alt="">' : '') + '</div><div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;"><span style="font-size:10px;font-weight:600;color:#333;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;">' + esc(name) + '</span><span style="font-size:12px;font-weight:800;color:#000;">' + esc(p.price) + '</span></div></a>';
          html += '<button type="button" data-vid="' + esc(p.vid) + '" aria-label="Add ' + esc(p.title) + ' to cart" style="width:90%;height:28px;border-radius:50px;background:#000;color:#fff;border:none;font-size:10px;font-weight:700;cursor:pointer;letter-spacing:.03em;margin-top:-2px;">+ Add</button>';
        } else {
          if (i > 0) html += '<div style="width:48px;height:1px;background:#f0f0f0;flex-shrink:0;"></div>';
          html += '<div style="display:flex;flex-direction:column;align-items:center;gap:5px;width:100%;"><a href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '" style="display:flex;align-items:center;justify-content:center;width:66px;height:66px;border-radius:8px;overflow:hidden;border:1px solid #ebebeb;background:#f8f8f8;flex-shrink:0;text-decoration:none;">' + (p.img ? '<img src="' + esc(p.img) + '" style="width:100%;height:100%;object-fit:contain;" alt="">' : '') + '</a><span style="font-size:11px;font-weight:800;color:#000;text-align:center;display:block;">' + esc(p.price) + '</span><button type="button" data-vid="' + esc(p.vid) + '" aria-label="Add ' + esc(p.title) + ' to cart" style="width:72px;height:26px;border-radius:50px;background:#000;color:#fff;border:none;font-size:10px;font-weight:700;cursor:pointer;letter-spacing:.03em;">+ Add</button></div>';
        }
      });
      pb.innerHTML = html;
      function applyState() {
        tab.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) { pb.style.width = barW; pb.style.opacity = '1'; pb.style.padding = '10px ' + (isDsk ? '12' : '6') + 'px 14px'; pb.style.overflow = 'auto'; pb.style.visibility = 'visible'; arrow.style.transform = 'rotate(0deg)'; }
        else { pb.style.width = '0'; pb.style.opacity = '0'; pb.style.padding = '0'; pb.style.overflow = 'hidden'; pb.style.visibility = 'hidden'; arrow.style.transform = 'rotate(180deg)'; }
      }
      tab.addEventListener('click', function () { isOpen = !isOpen; applyState(); });
      applyState(); wrap.appendChild(tab); wrap.appendChild(pb); document.body.appendChild(wrap);
      pb.querySelectorAll('button[data-vid]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = parseInt(btn.getAttribute('data-vid'), 10); btn.textContent = '✓'; btn.style.background = '#16a34a';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
            .then(function () { setTimeout(function () { btn.textContent = '+ Add'; btn.style.background = '#000'; }, 2000); })
            .catch(function () { btn.textContent = '+ Add'; btn.style.background = '#000'; });
        });
      });
      setTimeout(function () { wrap.style.opacity = '1'; wrap.style.pointerEvents = ''; }, 1500);   // the old page waited for its loader
      periph = wrap;
    }

    /* ---------- Clarity (desktop actions; reviews links are tagged by dg-duo.js's page-wide handler) ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('button,a'); if (!t) return;
      if (t.matches('.pdp__atc,[data-dgh-bar-add]')) ev('duo_add_to_cart');
      else if (t.matches('[data-dgh-buynow]')) ev('duo_buy_now');
      else if (t.matches('[data-dgh-replay]')) ev('duo_replay');
      else if (t.matches('[data-dgh-qty-dec],[data-dgh-qty-inc]')) ev('duo_qty');
      else if (t.matches('.dgh-bc')) ev('duo_bc');
    }, true);
    root.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-dgh-qty-in]')) ev('duo_qty'); }, true);

    return {
      enter: function () { mount3D(); buildPeriph(); pin(); },
      leave: function () { unmount3D(); if (periph) periph.style.display = 'none'; lbHide(); setBar(false); }
    };
  }
})();
